import { default as axios } from '../utils/axios.instances' // eslint-disable-line
import router from '@/router'
import store from '@/store'

const axiosInstance = axios.getSTAxios() // eslint-disable-line

const AUTH_TOKEN = 'auth_token'
const EXPIRE_AT = 'auth_token_expiration'

export function doLogin ({ email, password }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/auth/jwt/', { email, password }).then((res) => {
      let expiresAt = JSON.stringify(24 * 60 * 60 * 1000 + new Date().getTime())
      localStorage.setItem(AUTH_TOKEN, res.data.token)
      localStorage.setItem(EXPIRE_AT, expiresAt)
      resolve(res.data.token)
    }).catch((err) => {
      reject(err)
    })
  })
}

export function changeUserPassword (form) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/me/change-password/', form).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err.response.data)
    })
  })
}

export function clearLocalStorage () {
  localStorage.removeItem(AUTH_TOKEN)
  localStorage.removeItem(EXPIRE_AT)
}

export function doLogout () {
  clearLocalStorage()
  router.replace('/login')
}

export function authenticated () {
  // Check whether the current time is past the
  // access token's expiry time
  let expiresAt = JSON.parse(localStorage.getItem(EXPIRE_AT))
  return new Date().getTime() < expiresAt
}

export function isLoggedIn () {
  const token = getAuthToken()
  return !!token && authenticated()
}

export function requireAuth (to, from, next) {
  if (!isLoggedIn()) {
    next('/login')
  } else {
    if (!store.getters.profile || !store.getters.profile.organization) {
      const authToken = getAuthToken()
      axios.setSTAuthToken(authToken)
      store.dispatch('setAuthToken', authToken)
      store.dispatch('getUserProfile').then(() => {
        next()
      })
    } else {
      next()
    }
  }
}

export function getAuthToken () {
  return localStorage.getItem(AUTH_TOKEN)
}

export function getUserProfile () {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/me/').then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}
